// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_e-1";
export var movingGradient = "_e-4";
export var movingGradientBlock = "_e-2";
export var skeleton = "_e-0";
export var skeletonText = "_e-3";